
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-more_vert",
  "use": "icon-material-more_vert-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-more_vert\"><path d=\"M480.04-151.87q-21 0-35.83-14.91-14.84-14.92-14.84-35.86 0-20.72 14.9-35.73 14.89-15 35.81-15 21.12 0 35.83 15.12 14.72 15.11 14.72 35.91t-14.8 35.63q-14.8 14.84-35.79 14.84m0-277.5q-21 0-35.83-14.9-14.84-14.89-14.84-35.81 0-21.12 14.9-35.83 14.89-14.72 35.81-14.72 21.12 0 35.83 14.8 14.72 14.8 14.72 35.79 0 21-14.8 35.83-14.8 14.84-35.79 14.84m0-277.26q-21 0-35.83-14.99-14.84-14.98-14.84-36.03t14.9-35.88q14.89-14.84 35.81-14.84 21.12 0 35.83 14.98 14.72 14.98 14.72 36.02 0 21.05-14.8 35.89-14.8 14.85-35.79 14.85\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-more_vert"/>
                </svg>
            );
        };

        Icon.id = "icon-material-more_vert";

        export default Icon;
    